import React from 'react';
import './logo.css'; // Estilos para a logo

const Logo = () => {
  return (
    <div className="logo-container">
      <img
        src="logo.png"
        alt="Canadense"
        className="logo"
      />
    </div>
  );
};

export default Logo;